<template>
  <ion-page>
    <master-layout pageTitle="فراموشی کلمه عبور">
      <AjaxForm route="user/changePassword">
        <ion-card>
          <ion-card-content>
            <div class="mb-2">
              <label>گذرواژه پیشین</label>
              <input type="password" name="old_pass" class="form-control">
            </div>
            <div class="mb-2">
              <label>گذرواژه جدید</label>
              <input type="password" name="new_pass" class="form-control">
            </div>
            <div class="mb-2">
              <label>تکرار گذرواژه</label>
              <input type="password" name="re_enter_pass" class="form-control">
            </div>

            <button class="btn btn-block btn-lg btn-success mt-2" type="submit">
              تغییر <i class="fas fa-plus"></i>
            </button>
          </ion-card-content>
        </ion-card>

      </AjaxForm>
    </master-layout>
  </ion-page>
</template>

<script>
import {IonPage} from '@ionic/vue';
import {mapActions} from "vuex";
import AjaxForm from "@/components/AjaxForm";
// import {showSystemNoti} from '@/shared/helper'

// import {getFormData} from '@/shared/helper'

export default {
  name: "AddWarehouse",
  components: {
    AjaxForm,
    IonPage
  },
  data()
  {
    return {
      states: [],
      cities: [{_id: 0, title: 'ابتدا استان را انتخاب نمایید'}]
    }
  },
  async mounted()
  {
    this.states = await this.getStates();
  },
  methods: {
    ...mapActions("app", {
      getStates: 'getStates',
      apiGetCities: 'getCities',
    }),
    async getCities(event)
    {
      const result = await this.apiGetCities(event.target.value);
      if (result)
      {
        this.cities = result.cities;
      }
    }
  }
}

</script>

<style scoped>

</style>